import { createFileRoute } from "@tanstack/react-router";
import Fencing from "@/pages/Fencing";
import { buildHead } from "@/lib/seo";

const areaServed = [
  { "@type": "City", name: "Fort Lauderdale" },
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Pembroke Pines" },
  { "@type": "City", name: "Weston" },
  { "@type": "City", name: "Miramar" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Davie" },
  { "@type": "City", name: "Miami" },
  { "@type": "City", name: "Tampa" },
  { "@type": "City", name: "Orlando" },
];

export const Route = createFileRoute("/services/fencing")({
  head: () =>
    buildHead({
      title:
        "PVC, Wood & Aluminum Fencing in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Premium fence installation in Fort Lauderdale, Coral Springs, Weston, and across Broward County. PVC, wood, and aluminum fencing for privacy, security, and pool enclosures. Family-owned. Free estimates.",
      path: "/services/fencing",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Fencing Installation",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed,
          url: "https://precisionpaverspools.com/services/fencing",
          description:
            "Expert PVC, wood, and aluminum fencing installation in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Services",
              item: "https://precisionpaverspools.com/services",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Fencing",
              item: "https://precisionpaverspools.com/services/fencing",
            },
          ],
        },
      ],
    }),
  component: Fencing,
});
